import React from 'react';

interface LoanTypeTabProps {
  id: string;
  title: string;
  icon: React.ComponentType<any>;
  color: string;
  isActive: boolean;
  onClick: (id: string) => void;
}

const LoanTypeTab: React.FC<LoanTypeTabProps> = ({
  id,
  title,
  icon: Icon,
  color,
  isActive,
  onClick
}) => {
  return (
    <button
      onClick={() => onClick(id)}
      className={`
        flex items-center gap-2 md:gap-3 px-3 md:px-6 py-3 md:py-4 rounded-lg font-semibold transition-all duration-300 whitespace-nowrap flex-shrink-0
        ${isActive 
          ? 'bg-white shadow-lg border-2 text-[#2c3e50]' 
          : 'bg-gray-100 hover:bg-white hover:shadow-md border-2 border-transparent text-gray-600 hover:text-[#2c3e50]'
        }
      `}
      style={{
        borderColor: isActive ? color : 'transparent'
      }}
    >
      <Icon 
        className="h-5 w-5 md:h-6 md:w-6" 
        style={{ color: isActive ? color : 'currentColor' }}
      />
      <span className="text-xs md:text-sm lg:text-base">{title}</span>
    </button>
  );
};

export default LoanTypeTab; 